module.exports = __webpack_public_path__ + "static/media/Sharp-LQ080Y3LW01A-Mechanical-Drawing.fd1f8dc8.jpeg";